import * as moment from 'moment';

import { Component, OnInit } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';
import { BookingHoliday } from './../../models/bookings/bookings.model';

@Component({
  selector: 'swb-booking-holiday-list',
  templateUrl: './booking-holiday-list.component.html'
})
export class BookingHolidayListComponent extends ListBase<BookingHoliday> implements OnInit {

  public url = 'booking-holidays';
  public urlPrefix = 'bookings';
  public routePrefix = 'holidays';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }
  public dateFormat(date: string): string {
    return moment.utc(date).format('DD.MM.Y');
  }
}
